import { createFileRoute, redirect } from "@tanstack/react-router";

// German-language variant of /imprint — same destination.
export const Route = createFileRoute("/impressum")({
  beforeLoad: () => {
    throw redirect({ to: "/about", statusCode: 301 });
  },
});
